import * as DOMPurify from 'dompurify';

const HTML_TAG = /<\/?[a-z][\s\S]*?>/i;

const escapeHtml = (text: string) => text
  .replace(/&/g, '&amp;')
  .replace(/</g, '&lt;')
  .replace(/>/g, '&gt;');

/**
 * Sanitizes WYSIWYG-authored text for [innerHTML] (DOMPurify defaults, as for Screening Description).
 * Plain text keeps its line breaks; links open in a new tab. Bind the result with
 * bypassSecurityTrustHtml so inline styles survive.
 */
export function toRichTextHtml(raw: string): string {
  if (!raw) { return ''; }
  const source = HTML_TAG.test(raw) ? raw : escapeHtml(raw).replace(/\r?\n/g, '<br>');
  const fragment: DocumentFragment = DOMPurify.sanitize(source, { RETURN_DOM_FRAGMENT: true }) as any;
  Array.from(fragment.querySelectorAll('a')).forEach((link: HTMLAnchorElement) => {
    link.setAttribute('target', '_blank');
    link.setAttribute('rel', 'noopener');
  });
  const container = document.createElement('div');
  container.appendChild(fragment);
  return container.innerHTML;
}
